"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MaxPooling1D", {
  enumerable: true,
  get: function () {
    return _MaxPooling1D.default;
  }
});
Object.defineProperty(exports, "MaxPooling2D", {
  enumerable: true,
  get: function () {
    return _MaxPooling2D.default;
  }
});
Object.defineProperty(exports, "MaxPooling3D", {
  enumerable: true,
  get: function () {
    return _MaxPooling3D.default;
  }
});
Object.defineProperty(exports, "AveragePooling1D", {
  enumerable: true,
  get: function () {
    return _AveragePooling1D.default;
  }
});
Object.defineProperty(exports, "AveragePooling2D", {
  enumerable: true,
  get: function () {
    return _AveragePooling2D.default;
  }
});
Object.defineProperty(exports, "AveragePooling3D", {
  enumerable: true,
  get: function () {
    return _AveragePooling3D.default;
  }
});
Object.defineProperty(exports, "GlobalMaxPooling1D", {
  enumerable: true,
  get: function () {
    return _GlobalMaxPooling1D.default;
  }
});
Object.defineProperty(exports, "GlobalMaxPooling2D", {
  enumerable: true,
  get: function () {
    return _GlobalMaxPooling2D.default;
  }
});
Object.defineProperty(exports, "GlobalMaxPooling3D", {
  enumerable: true,
  get: function () {
    return _GlobalMaxPooling3D.default;
  }
});
Object.defineProperty(exports, "GlobalAveragePooling1D", {
  enumerable: true,
  get: function () {
    return _GlobalAveragePooling1D.default;
  }
});
Object.defineProperty(exports, "GlobalAveragePooling2D", {
  enumerable: true,
  get: function () {
    return _GlobalAveragePooling2D.default;
  }
});
Object.defineProperty(exports, "GlobalAveragePooling3D", {
  enumerable: true,
  get: function () {
    return _GlobalAveragePooling3D.default;
  }
});

var _MaxPooling1D = _interopRequireDefault(require("./MaxPooling1D"));

var _MaxPooling2D = _interopRequireDefault(require("./MaxPooling2D"));

var _MaxPooling3D = _interopRequireDefault(require("./MaxPooling3D"));

var _AveragePooling1D = _interopRequireDefault(require("./AveragePooling1D"));

var _AveragePooling2D = _interopRequireDefault(require("./AveragePooling2D"));

var _AveragePooling3D = _interopRequireDefault(require("./AveragePooling3D"));

var _GlobalMaxPooling1D = _interopRequireDefault(require("./GlobalMaxPooling1D"));

var _GlobalMaxPooling2D = _interopRequireDefault(require("./GlobalMaxPooling2D"));

var _GlobalMaxPooling3D = _interopRequireDefault(require("./GlobalMaxPooling3D"));

var _GlobalAveragePooling1D = _interopRequireDefault(require("./GlobalAveragePooling1D"));

var _GlobalAveragePooling2D = _interopRequireDefault(require("./GlobalAveragePooling2D"));

var _GlobalAveragePooling3D = _interopRequireDefault(require("./GlobalAveragePooling3D"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }